import apiServices from 'api_services/request-handler';
import { requestHandler } from 'utils/functions';
import { AppDispatch } from '../store';

import { setDeleteLoading, setUserLoading, setUsers } from '../slices/user-slice';
import { setUser } from '../slices/common-slice';

export const getUsers = (params: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getUsers,
        param_data: params,
        setLoading: setUserLoading,
        setData: setUsers,
      }),
    );
  };
};
export const getUserDetail = (params: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getUserDetail,
        param_data: params?.userId,
        setLoading: setUserLoading,
        onDone: (data: any) => dispatch(setUser({ ...params, ...data?.data?.data })),
      }),
    );
  };
};

export const createUser = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.createUser,
        setLoading: setUserLoading,
        isSuccessMessage: true,
        param_data: data,
        onDone
      }),
    );
  };
};

export const updateUser = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.updateUser,
        setLoading: setUserLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone
      }),
    );
  };
};

export const deleteUser = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.deleteUser,
        setLoading: setDeleteLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone
      }),
    );
  };

};

export const changePassword = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.changePassword,
        setLoading: setUserLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone
      }),
    );
  };
}

